var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconFeedback = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon-feedback",
    width: 58,
    height: 52,
    viewBox: "0 0 58 52",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n.icon-feedback .a{fill:#86a5d5;} \n.icon-feedback .b{fill:#fff;}\n"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-931 -181)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6,3H30a3,3,0,0,1,2.985,3L33,33l-6-6H6a3.009,3.009,0,0,1-3-3V6A3.009,3.009,0,0,1,6,3Z",
    transform: "translate(956 178)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M41.7,3H7.3A4.294,4.294,0,0,0,3.021,7.3L3,46l8.6-8.6H41.7A4.313,4.313,0,0,0,46,33.1V7.3A4.313,4.313,0,0,0,41.7,3ZM26.65,28.8h-4.3V24.5h4.3Zm0-8.6h-4.3V11.6h4.3Z",
    transform: "translate(928 187)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconFeedback, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_feedback.89eaa2f1.svg";
export { ForwardRef as ReactComponent };